module.exports = __webpack_public_path__ + "static/media/gifOne.21ac5dc5.gif";